import { useSwrNoAuth } from "../../swr/useSwrNoAuth";


export const useFetchHasTwelveHoursPassedSinceLastRoulette = (lineAccountId: string | null) => {
  const fetcherKey = lineAccountId ? `games/roulette/line-accounts/${lineAccountId}/has-12-hours-passed/` : null;
  const { data: has12HoursPassed, error, isLoading, isValidating } = useSwrNoAuth<boolean>(fetcherKey)
  return { has12HoursPassed, isLoading, error, isValidating };
}